export default "__VITE_PUBLIC_ASSET__ba06c152__"